import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/automatch_150.png'


const _withScopeId = n => (_pushScopeId("data-v-1638b9be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import CompactItem from '@/util/CompactItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SystemGroupItem',
  props: {
    small: { type: Boolean },
    static: { type: Boolean },
    showHover: { type: Boolean },
    highlightMode: { type: Boolean },
    highlighted: { type: Boolean },
    highlightSource: { type: Boolean },
    highlightSourceSelected: { type: Boolean }
  },
  emits: ["highlight"],
  setup(__props: any, { emit }) {

const props = __props;





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CompactItem, {
    class: "system-group-item",
    shadow: "",
    small: _ctx.small,
    static: _ctx.static,
    "show-hover": _ctx.showHover,
    "highlight-mode": _ctx.highlightMode,
    highlighted: _ctx.highlighted,
    "highlight-source": _ctx.highlightSource,
    "highlight-source-selected": _ctx.highlightSourceSelected,
    onHighlight: _cache[0] || (_cache[0] = value => emit('highlight', value))
  }, {
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => [
      _createTextVNode("Auto-matching")
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode("Built-in")
    ]),
    _: 1
  }, 8, ["small", "static", "show-hover", "highlight-mode", "highlighted", "highlight-source", "highlight-source-selected"]))
}
}

})